export default __webpack_public_path__ + "static/media/houseNumberShowOff.301b87a6.svg";